export default __webpack_public_path__ + "73504a7f8892f4cabdaf1066b0504ce4.png";